import { useQuery } from '@tanstack/react-query';
import { useUserIdentityState } from '@provider/user-identity';
import { DAYS_TO_MS, SECONDS_TO_MS } from '@utils/constants';
import { getNotificationsRequest } from './api.get-notifications.request.js';

const getNotificationsKey = user => ["user-area/get-notifications", user?.id];
const getNotificationsQuery = user => {
  return {
    queryKey: getNotificationsKey(user),
    queryFn: () => getNotificationsRequest(user),
    staleTime: 15 * SECONDS_TO_MS,
    gcTime: 7 * DAYS_TO_MS,
    meta: {
      persist: true
    }
  };
};
const useGetNotificationsQuery = extraConfig => {
  const user = useUserIdentityState(state => state.user);
  return useQuery({
    ...getNotificationsQuery(user),
    ...extraConfig
  });
};

export { getNotificationsKey, getNotificationsQuery, useGetNotificationsQuery };
//# sourceMappingURL=api.get-notifications.query.js.map
